import { render, staticRenderFns } from "./IndividualInfo.vue?vue&type=template&id=24f2d128"
import script from "./IndividualInfo.vue?vue&type=script&lang=js"
export * from "./IndividualInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports